import React, { useState } from "react";
import { Add } from "@mui/icons-material";
import { Container, Typography, Tab, Box, Button } from "@mui/material";
import TabsMenu from "../../components/TabsMenu";
import { TabPanel } from "@mui/lab";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import { writeLog } from "../../services/services";
import { styles } from "../../utils/styles";
import { Link } from 'react-router-dom';
import { ROLES, SCOPE_IDENTIFIERS, prefixV3 } from "../../utils/constants";

// Components
import AllOnboarding from "./all";
// import PendingOnboarding from "./pending";
import HistoryOnboarding from "./history";

const OnboardingPage = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  const [createDialog, setCreateDialog] = useState(false);

  return (
    <Container>
      <HeaderHelpPage title="Onboarding" description="Allow Oxygen7 user to manage a onboarding." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        {/* <Tab label="Pending" value="Pending" /> */}
        {/* <Tab label="History" value="History" /> */}
        <TabPanel value="All">
          <AllOnboarding userRole={userRole} />
        </TabPanel>
        {/* <TabPanel value="Pending">
          <PendingOnboarding userRole={userRole} />
        </TabPanel> */}
        {/* <TabPanel value="History">
          <HistoryOnboarding userRole={userRole} />
        </TabPanel> */}
        {userRole && userRole.includes('Add') && (
            <Box>
              <Button
                variant="contained"
                component={Link}
                to={prefixV3 + "/operations/onboarding/create"}
                onClick={() => {
                  window.localStorage.removeItem('onboarding_draft');
                  writeLog('[Info] - Click button [Add new Onboarding Application] - Open new tab to Create A New Onboarding Application')
                }}
                startIcon={<Add />}
                sx={{ ...styles.customButton }}
              >
                New Application
              </Button>
            </Box>
          )}
      </TabsMenu>
      {/* {createDialog && <CreateNewOnboarding open={true} onClose={() => setCreateDialog(false)} />} */}
    </Container>
  );
};

export default OnboardingPage;